import { render, staticRenderFns } from "./barca2526.vue?vue&type=template&id=3b76e2f8&scoped=true&"
import script from "./barca2526.vue?vue&type=script&lang=js&"
export * from "./barca2526.vue?vue&type=script&lang=js&"
import style0 from "./barca2526.vue?vue&type=style&index=0&id=3b76e2f8&lang=scss&scoped=true&"
import style1 from "./barca2526.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b76e2f8",
  null
  
)

export default component.exports